export default __webpack_public_path__ + "../staticImages/strand_rot-260.png";